<template>
  <div className="section-table">
    <table :aria-label="description">
      <tbody>
        <tr v-if="props.headers">
          <th v-for="(header, headerIndex) in props.headers" :key="headerIndex">
            {{ header }}
          </th>
        </tr>
        <tr v-for="(row, rowIndex) in props.rows" :key="rowIndex">
          <td>{{ row[0] }}</td>
          <td v-for="(cell, cellIndex) in row.slice(1)" :key="cellIndex">
            <span class="font-bold">
              {{ cell }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
export type TableProps = {
  description: string;
  headers?: Array<string | null | undefined> | undefined;
  rows: Array<(string | null | undefined)[]>;
};

const props = defineProps<TableProps>();
</script>

<style scoped>
.section-table {
  overflow-x: auto;
}

.section-table table {
  border-collapse: collapse;
  width: 100%;
}

.section-table td,
.section-table th {
  position: relative;
  vertical-align: top;
  padding: 0.6em 0;
  padding-right: 1em;
  font-weight: var(--font-weight-normal);
  text-align: left;
}

.section-table th:not(:first-child) {
  border-bottom: 1px solid var(--neutral-50);
}

.section-table tr > *:first-child {
  padding-left: 2em;
}

.section-table tr > *:first-child:before {
  display: block;
  position: absolute;
  bottom: 50%;
  left: 0.7em;
  border-bottom: 1px solid var(--neutral-50);
  border-left: 1px solid var(--neutral-50);
  width: 1em;
  height: 50%;
  content: "";
}

.section-table tr th:first-child:before {
  border-bottom: none;
}

.section-table tr:not(:last-child) > *:first-child:after {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0.7em;
  border-left: 1px solid var(--neutral-50);
  width: 1em;
  height: 50%;
  content: "";
}
</style>
